export default __webpack_public_path__ + "static/media/email-unsubscribed.c4a89d4b.svg";